import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

function WaiterSetup({ onConfigured, onJustConfigured }) {
  const html5QrCodeRef = useRef(null);

  const [cameras, setCameras] = useState([]);
  const [currentCameraIndex, setCurrentCameraIndex] = useState(0);
  const [cameraSupported, setCameraSupported] = useState(true);

  const [isConfigured, setIsConfigured] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  const [waiterLocale, setWaiterLocale] = useState(
    localStorage.getItem("waiter_locale")
  );
  const [waiterId, setWaiterId] = useState(
    localStorage.getItem("waiter_id")
  );

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

  const shouldShowIOSInstallCard = isIOS && !isStandalone;

  useEffect(() => {
    if (window.__WAITER_INSTALL_PROMPT) {
      setDeferredPrompt(window.__WAITER_INSTALL_PROMPT);
    }

    const syncPrompt = () => {
      if (window.__WAITER_INSTALL_PROMPT) {
        setDeferredPrompt(window.__WAITER_INSTALL_PROMPT);
      }
    };

    window.addEventListener("focus", syncPrompt);
    return () => window.removeEventListener("focus", syncPrompt);
  }, []);

  useEffect(() => {
    if (shouldShowIOSInstallCard) return;
    if ((waiterLocale && waiterId) && !isConfigured) return;

    const initDelay = isStandalone ? 800 : 200;

    let cancelled = false;
    let started = false;

    const startScanner = async () => {
      if (started || cancelled) return;

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setCameraSupported(false);
        return;
      }

      if (document.visibilityState !== "visible" || !document.hasFocus()) {
        started = false;
        setTimeout(() => {
          if (!cancelled) startScanner();
        }, 500);
        return;
      }

      const qrRegionId = "qr-reader";
      const qrElement = document.getElementById(qrRegionId);

      if (!qrElement) {
        started = false;
        setTimeout(() => {
          if (!cancelled) startScanner();
        }, 300);
        return;
      }

      if (!html5QrCodeRef.current) {
        html5QrCodeRef.current = new Html5Qrcode(qrRegionId);
      }

      try {
        started = true;

        const devices = await Html5Qrcode.getCameras();

        if (!devices || !devices.length) {
          started = false;
          setTimeout(() => {
            if (!cancelled) startScanner();
          }, 800);
          return;
        }

        setCameras(devices);

const backIndex = devices.findIndex((d) => {
  const label = (d.label || "").toLowerCase();
  return (
    label.includes("back") ||
    label.includes("rear") ||
    label.includes("environment") ||
    label.includes("posteriore") ||
    label.includes("retro")
  );
});

const startIndex = backIndex !== -1 ? backIndex : devices.length - 1;
setCurrentCameraIndex(startIndex);

setTimeout(() => {
  if (!cancelled) {
    startCamera(devices[startIndex].id);
  }
}, initDelay);
      } catch (err) {
        started = false;
        setTimeout(() => {
          if (!cancelled) startScanner();
        }, 800);
      }
    };

    const bootTimer = setTimeout(() => {
      startScanner();
    }, initDelay);

    const retryInterval = setInterval(() => {
      if (cancelled) return;

      if (html5QrCodeRef.current && html5QrCodeRef.current._isScanning) {
        clearInterval(retryInterval);
        return;
      }

      startScanner();
    }, 1000);

return () => {
  clearTimeout(bootTimer);
  clearInterval(retryInterval);
  cancelled = true;

  const qr = html5QrCodeRef.current;
  html5QrCodeRef.current = null;

  if (qr) {
    const isScanning =
      typeof qr.isScanning === "function"
        ? qr.isScanning()
        : !!qr._isScanning;

    if (isScanning) {
      qr.stop()
        .then(() => qr.clear?.())
        .catch(() => {});
    } else {
      qr.clear?.().catch?.(() => {});
    }
  }
};
  }, [shouldShowIOSInstallCard, isStandalone, waiterLocale, waiterId, isConfigured]);

const startCamera = (cameraId) => {
  if (!html5QrCodeRef.current) return;

  const cameraConfig = cameraId
    ? { deviceId: { exact: cameraId } }
    : { facingMode: "environment" };

  html5QrCodeRef.current.start(
    cameraConfig,
      { fps: 10, qrbox: 250 },
      async (decodedText) => {
        try {
          const url = new URL(decodedText);
          const locale = url.searchParams.get("locale");
          const cameriere = url.searchParams.get("cameriere");

          if (locale && cameriere) {
            localStorage.setItem("waiter_locale", locale);
            localStorage.setItem("waiter_id", cameriere);

            setWaiterLocale(locale);
            setWaiterId(cameriere);

            window.history.replaceState({}, document.title, "/");


            localStorage.setItem("waiter_just_configured", "true");
            window.location.reload();

localStorage.setItem("waiter_just_configured", "true");

const qr = html5QrCodeRef.current;
html5QrCodeRef.current = null;

if (qr) {
  try {
    await qr.stop();
    await qr.clear?.();
  } catch (e) {
    console.warn("Scanner già chiuso:", e);
  }
}

window.location.reload();
          }
        } catch {
          console.log("QR non valido");
        }
      },
      () => {}
    );
  };

  const switchCamera = async () => {
    if (!cameras.length || !html5QrCodeRef.current) return;

    const nextIndex = (currentCameraIndex + 1) % cameras.length;

    await html5QrCodeRef.current.stop().catch(() => {});
    setCurrentCameraIndex(nextIndex);
    startCamera(cameras[nextIndex].id);
  };

  if (shouldShowIOSInstallCard) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(180deg, #0f0f12 0%, #18181c 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "1.5rem",
          color: "#fff"
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "360px",
            textAlign: "center",
            padding: "2rem",
            borderRadius: "28px",
            background: "rgba(255,255,255,0.04)",
            backdropFilter: "blur(12px)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
            border: "1px solid rgba(255,255,255,0.06)"
          }}
        >
          {/* ICONA */}
          <div
            style={{
              width: "70px",
              height: "70px",
              margin: "0 auto 1.2rem",
              borderRadius: "20px",
              background: "linear-gradient(135deg, #0a84ff, #5ac8fa)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "30px"
            }}
          >
            📲
          </div>

          {/* TITOLO */}
          <h2 style={{ marginBottom: "0.5rem" }}>
            Aggiungi QrMenu
          </h2>

          {/* DESCRIZIONE */}
          <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "1.5rem" }}>
            Per lavorare meglio, aggiungi l’app alla schermata Home del tuo iPhone.
          </p>

          {/* ISTRUZIONI */}
          <div
            style={{
              fontSize: "0.85rem",
              color: "#ccc",
              marginBottom: "1.5rem",
              lineHeight: 1.4
            }}
          >
            1. Tocca <b>Condividi</b> (⬆️)<br />
            2. Seleziona <b>"Aggiungi alla schermata Home"</b>
          </div>

          {/* BUTTON */}
          <button
            onClick={() => window.location.reload()}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "16px",
              border: "none",
              background: "linear-gradient(135deg, #0a84ff, #007aff)",
              color: "#fff",
              fontWeight: "600",
              fontSize: "0.95rem"
            }}
          >
            Ho aggiunto l'app
          </button>

          {/* SALTA */}
          <button
            onClick={() => window.location.reload()}
            style={{
              width: "100%",
              marginTop: "10px",
              padding: "12px",
              borderRadius: "14px",
              background: "transparent",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#aaa"
            }}
          >
            Continua senza installare
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      {!cameraSupported ? (
        <div>
          <h3>Fotocamera non disponibile</h3>
          <button onClick={() => window.open(window.location.origin, "_blank")}>
            Apri in Chrome
          </button>
        </div>
      ) : (
        <>
          <h2>Configura Cameriere</h2>
          <p>Inquadra il QR</p>

          <div id="qr-reader" style={{ width: "300px", margin: "auto" }} />

          {cameras.length > 1 && (
            <button onClick={switchCamera}>
              🔄 Cambia fotocamera
            </button>
          )}
        </>
      )}

      {isConfigured && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "1.2rem"
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              color: "#111",
              borderRadius: "20px",
              padding: "1.6rem",
              width: "100%",
              maxWidth: "360px",
              textAlign: "center",
              boxShadow: "0 20px 50px rgba(0,0,0,0.18)"
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: "0.8rem" }}>
              Configurazione completata!
            </h2>

            {!isStandalone && (
              <>
                <p style={{ marginBottom: "1rem", color: "#444" }}>
                  Ora puoi installare la PWA del cameriere.
                </p>

                <button
                  disabled={!deferredPrompt}
                  onClick={async () => {
                    if (!deferredPrompt) return;

                    deferredPrompt.prompt();
                    const choice = await deferredPrompt.userChoice;

                    if (choice.outcome === "accepted") {
                      window.location.reload();
                    }
                  }}
                  style={{
                    padding: "12px",
                    borderRadius: "12px",
                    border: "none",
                    backgroundColor: "#111",
                    color: "#fff",
                    width: "100%",
                    opacity: deferredPrompt ? 1 : 0.5,
                    cursor: deferredPrompt ? "pointer" : "not-allowed"
                  }}
                >
                  📲 Installa app
                </button>
              </>
            )}

            {isStandalone && (
              <>
                <p style={{ marginBottom: "1rem", color: "#444" }}>
                  Configurazione salvata correttamente.
                </p>

                <button
                  onClick={onConfigured}
                  style={{
                    padding: "12px",
                    borderRadius: "12px",
                    border: "none",
                    backgroundColor: "#111",
                    color: "#fff",
                    width: "100%",
                    cursor: "pointer"
                  }}
                >
                  Continua
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default WaiterSetup;